import { render, staticRenderFns } from "./CardProjectTable.vue?vue&type=template&id=8ea6c1ca&"
import script from "./CardProjectTable.vue?vue&type=script&lang=js&"
export * from "./CardProjectTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports